import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M7.22932 7.85934C6.31239 8.77627 5.84941 9.97171 5.83494 11.1726C5.83494 11.1798 5.83494 11.1889 5.83675 11.1961C5.93079 12.1347 6.33771 13.048 7.0557 13.7678L10.5588 17.271C10.6167 17.3288 10.7126 17.3288 10.7704 17.271L10.9025 17.1389C12.6151 15.4263 12.6151 12.6483 10.9025 10.9339L7.63263 7.66764C7.57475 7.60976 7.4789 7.60976 7.42103 7.66764L7.22932 7.85934ZM7.22932 7.85934C6.31059 8.77808 5.84597 9.97897 5.83331 11.1853C5.92555 12.1275 6.33247 13.0462 7.05408 13.7697L7.56047 14.2761L12.4037 9.43279C14.2665 7.57 14.2665 4.54794 12.4037 2.68333L7.22932 7.85934Z"
      stroke={fill}
      strokeWidth="1.6871"
      strokeMiterlimit="10"
      transform="scale(1.2 1.2) translate(-1 0)"
    />
  </g>
);

export default Icon;
